import { useState, useEffect, useContext} from "react"; 
import { Link, useParams} from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";

 
const PharamcyPage = () => {


  const { getPharmacy } = useContext(AdminContext);
  const params = useParams();
  const [pharmacy, setPharamcy] = useState(null);
  const [error, setError] = useState(null)



  useEffect(() => {
    getPharmacy(params.phId).then((res) => {  
         
        if(res.status === 200) {
          document.title = 'Аптека №' + res.data.num
          return setPharamcy(res.data)}
        else {
            setError(res.data.message)
        }

    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); 

  return (
    <div className="container">
      <div className="admin__user">
       
        <ButtonBack/>

        <div style={{ position: 'relative', minHeight: 120 }}>
          {(!pharmacy && !error) ? (
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          ) : (
            error ? <ErrorMessage message={error}/>: <>
            <div className="admin__user">
              <div className="admin__user__name">Аптека: {pharmacy.num}</div>
            </div>

            <div className="admin__user">
              <div className="admin__user__name">
                МАС:
                <Link to={`/admin/mas/${pharmacy.masId}`}>
                { `${pharmacy.surname} `}
                  {pharmacy.name[0]}.
                          
                </Link>
              </div>
            </div>
            <div className="admin__user">
              <div className="admin__user__name">Кол-во тестируемых: {pharmacy.count}</div>
            </div>

            
          </>
          )
          }
        </div>
      </div>
    </div>
  );
};

export default PharamcyPage;
